import resourceService from './resource_service';

const modelName = 'chemical-manufacturer';

const attributes = {
  name: '',
};

const relationships = {
  chemicals: {
    jsonApi: 'hasMany',
  },
  permissions: {
    jsonApi: 'hasMany',
  },
};

export default resourceService(modelName, attributes, relationships);
